import { Constants } from './../utils/constants';
import { createUpdateUserFavouriteFetchDataStatusAction } from './../actions/userFavouriteActions';
export function shouldPerformFetchFavourite(fetchDataStatus) {
    // fetch favourite data only if favourite entity state is invalid
    return fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Invalid;
}
/**
 * invalidate redux favourite store by flagging fetch data status as invalid
 */ export function invalidateFavourites() {
    return (dispatch, getState)=>{
        const fetchDataStatus = Constants.UserFavourite.FetchDataStatus.Invalid;
        dispatch(createUpdateUserFavouriteFetchDataStatusAction({
            fetchDataStatus: fetchDataStatus
        }));
    };
}
/**
 * validate redux favourite store by flagging fetch data status as valid
 */ export function validateFavourites() {
    return (dispatch, getState)=>{
        const fetchDataStatus = Constants.UserFavourite.FetchDataStatus.Valid;
        dispatch(createUpdateUserFavouriteFetchDataStatusAction({
            fetchDataStatus: fetchDataStatus
        }));
    };
}
export function fetchPricing(entityId, applicationType) {
    return (dispatch, getState)=>{
        return Promise.resolve(undefined);
    };
}
/**
 * mark call failure to redux favourite store by flagging fetch data status as failure to avoid infinite loop
 */ export function failedDataStatus() {
    return (dispatch, getState)=>{
        const fetchDataStatus = Constants.UserFavourite.FetchDataStatus.Failure;
        dispatch(createUpdateUserFavouriteFetchDataStatusAction({
            fetchDataStatus: fetchDataStatus
        }));
    };
}
